import { useEffect, useState } from 'react';
import analyzePose from '../../../services/AnalyzePoseSerivce';

const ColloredTd1 = ({ scrType, scr }) => {
  const [bgColor, setBgColor] = useState('#ffffff');
  const [dpValue, setDpValue] = useState('');

  useEffect(() => {
    if (scr === undefined || scr === null || scr === '') {
      return;
    }
    let returnColor = '#ffffff';
    let scrNum = Number(scr);

    if (!isNaN(scrNum)) {
      if (scrType === 'OWAS') {
        if (scrNum >= 4) returnColor = '#dc3545';
        else if (scrNum >= 3) returnColor = '#ff4200';
        else if (scrNum >= 2) returnColor = '#ffa600';
        else returnColor = '#28a745';

        setDpValue('AC' + scrNum);
      } else if (scrType === 'RULA') {
        if (scrNum >= 7) returnColor = '#dc3545';
        else if (scrNum >= 5) returnColor = '#ffa600';
        else if (scrNum >= 3) returnColor = '#fff700';
        else returnColor = '#28a745';

        setDpValue(`${scrNum}`);
      } else if (scrType === 'REBA') {
        if (scrNum >= 11) returnColor = '#dc3545';
        else if (scrNum >= 8) returnColor = '#ff4200';
        else if (scrNum >= 4) returnColor = '#ffa600';
        else if (scrNum >= 2) returnColor = '#fff700';
        else returnColor = '#28a745';

        setDpValue(`${scrNum}`);
      }
    }

    setBgColor(returnColor);
  }, [scrType, scr]);

  return <td style={{ backgroundColor: bgColor }}>{dpValue}</td>;
};

const ConsultTotalResult = ({ rslt, onChangeRslt, param, id }) => {
  const [pageParam, setPageParam] = useState({ ...param });
  const [valueObj, setValueObj] = useState({ ...rslt });
  const [lblList, setLblList] = useState(valueObj.scoreLblList);
  const [selectedLbl, setSelectedLbl] = useState(valueObj.scoreLblList[0]?.lbl);
  const [frameList, setFrameList] = useState(() => {
    return [
      ...new Map(
        valueObj.scoreList.map(item => [
          item.frameNo,
          {
            frameNo: item.frameNo,
            thmb: item.thmb,
          },
        ])
      ).values(),
    ];
  });
  const [selectedFrame, setSelectedFrame] = useState(
    valueObj.scoreList[0]?.frameNo
  );
  const [selectedData, setSelectedData] = useState(valueObj.scoreList[0]);

  useEffect(() => {
    const tempSelect1 = valueObj.scoreList.filter(
      data => data.frameNo === selectedFrame
    );
    const tempLbl = tempSelect1.map(item => ({ lbl: item.anlsTrprLbl }));
    setLblList(tempLbl);

    const tempSelect2 = tempSelect1.filter(
      data => data.anlsTrprLbl === tempLbl[0].lbl
    )[0];

    setSelectedData(tempSelect2);
    setPoseInfo(convertDataToPoseInfo(tempSelect2));
  }, [selectedFrame]);

  useEffect(() => {
    setSelectedLbl(lblList[0]?.lbl);
  }, [lblList]);

  useEffect(() => {
    const tempSelect1 = valueObj.scoreList.filter(
      data => data.frameNo === selectedFrame
    );
    const tempSelect2 = tempSelect1.filter(
      data => data.anlsTrprLbl === selectedLbl
    )[0];

    setSelectedData(tempSelect2);
    setPoseInfo(convertDataToPoseInfo(tempSelect2));
  }, [selectedLbl]);

  const ColloredTd = ({ color, text, selected, colspan = 1 }) => {
    return (
      <>
        {selected ? (
          <td colSpan={colspan} style={{ backgroundColor: color }}>
            {text}
          </td>
        ) : (
          <td colSpan={colspan}>{text}</td>
        )}
      </>
    );
  };

  const options = {
    neck: {
      text: '목',
      position: [
        { code: 'NC_PT_00', text: '선택' },
        { code: 'NC_PT_01', text: '뒤로 젖힘' },
        { code: 'NC_PT_02', text: '0도 ~ 10도 굽힘' },
        { code: 'NC_PT_03', text: '10도 ~ 20도 굽힘' },
        { code: 'NC_PT_04', text: '20도 이상 굽힘' },
      ],
      adjust: [
        {
          code: 'NC_AJ_01',
          text: '비틀림',
          option: 'check',
        },
        {
          code: 'NC_AJ_02',
          text: '옆으로 구부림',
          option: 'check',
        },
      ],
    },
    trunk: {
      text: '몸통(허리)',
      pose: [
        { code: 'TR_PS_00', text: '선택' },
        { code: 'TR_PS_01', text: '곧바로 편 자세(서있음)' },
        {
          code: 'TR_PS_02',
          text: '상체를 앞으로 20도 이상 굽힌 자세',
        },
        {
          code: 'TR_PS_03',
          text: '바로 서서 허리를 옆으로 20도 이상 비튼 자세',
        },
        {
          code: 'TR_PS_04',
          text: '상체를 앞으로 굽힌 채 옆으로 비튼 자세',
        },
      ],
      position: [
        { code: 'TR_PT_00', text: '선택' },
        { code: 'TR_PT_01', text: '-20도 이상 뒤로' },
        { code: 'TR_PT_02', text: '20도 ~ 0도 뒤로' },
        { code: 'TR_PT_03', text: '똑바로' },
        { code: 'TR_PT_04', text: '0~20도 굽힘' },
        { code: 'TR_PT_05', text: '20도 ~ 60도 굽힘' },
        { code: 'TR_PT_06', text: '60도 이상 굽힘' },
      ],
      adjust: [
        { code: 'TR_AJ_01', text: '비틀림', option: 'check' },
        {
          code: 'TR_AJ_02',
          text: '옆으로 구부림',
          option: 'check',
        },
      ],
    },
    leg: {
      text: '다리',
      pose: [
        { code: 'LG_PS_00', text: '선택' },
        { code: 'LG_PS_01', text: '앉은 자세' },
        { code: 'LG_PS_02', text: '두 다리를 펴고 선 자세' },
        { code: 'LG_PS_03', text: '한 다리로 선 자세' },
        { code: 'LG_PS_04', text: '두 다리를 구부린 선 자세' },
        { code: 'LG_PS_05', text: '한 다리로 서서 구부린 선 자세' },
        { code: 'LG_PS_06', text: '무릎을 꿇는 자세' },
        { code: 'LG_PS_07', text: '걷기' },
      ],
      position: [
        { code: 'LG_PT_00', text: '선택' },
        { code: 'LG_PT_01', text: '한 다리로 지지' },
        { code: 'LG_PT_02', text: '두 다리로 지지' },
      ],
      adjust: [
        {
          code: 'LG_AJ_00',
          text: '선택',
          option: 'select',
        },
        {
          code: 'LG_AJ_01',
          text: '무릎이 30~60도 구부러질 경사시(앉은자세 제외)',
          option: 'select',
        },
        {
          code: 'LG_AJ_02',
          text: '무릎이 60도 이상 구부러질 시(앉은자세 제외)',
          option: 'select',
        },
        {
          code: 'LG_AJ_03',
          text: '앉은 자세(허리 지지됨)',
          option: 'check',
        },
        {
          code: 'LG_AJ_04',
          text: '앉은 자세(허리 지지 안됨)',
          option: 'check',
        },
      ],
    },
    upperArm: {
      text: '어깨(상완)',
      position: [
        { code: 'UA_PT_00', text: '선택' },
        { code: 'UA_PT_01', text: '-20도 이상 뒤로' },
        {
          code: 'UA_PT_02',
          text: '-20도 뒤로 ~ 20도 앞으로',
        },
        { code: 'UA_PT_03', text: '20~45도 앞으로' },
        { code: 'UA_PT_04', text: '45~90도 앞으로' },
        { code: 'UA_PT_05', text: '90도 이상 위로' },
      ],
      adjust: [
        { code: 'UA_AJ_01', text: '위팔 벌어지거나 회전', option: 'check' },
        { code: 'UA_AJ_02', text: '어깨들림', option: 'check' },
        {
          code: 'UA_AJ_03',
          text: '팔이 지지되거나 몸을 어딘가에 기댐',
          option: 'check',
        },
      ],
    },
    lowerArm: {
      text: '팔(팔꿈치)',
      pose: [
        { code: 'AA_PS_00', text: '선택' },
        { code: 'AA_PS_01', text: '양팔 어깨 아래' },
        { code: 'AA_PS_02', text: '한팔 어깨 위' },
        { code: 'AA_PS_03', text: '양팔 어깨 위' },
      ],
      position: [
        { code: 'LA_PT_00', text: '선택' },
        {
          code: 'LA_PT_01',
          text: '0 ~ 60도(위팔 수직선에서)',
        },
        {
          code: 'LA_PT_02',
          text: '60 ~ 100도(위팔 수직선에서)',
        },
        {
          code: 'LA_PT_03',
          text: '100도 이상(위팔 수직선에서)',
        },
      ],
      adjust: [
        {
          code: 'LA_AJ_01',
          text: '팔이 교차 또는 몸통을 벗어남',
          option: 'check',
        },
      ],
    },
    wrist: {
      text: '손목',
      position: [
        { code: 'WR_PT_00', text: '선택' },
        { code: 'WR_PT_01', text: '15도 이상 들림' },
        { code: 'WR_PT_02', text: '중립' },
        { code: 'WR_PT_03', text: '-15도 아래 ~ 15도 사이' },
        { code: 'WR_PT_04', text: '-15도 이상 꺾임' },
      ],
      adjust: [
        { code: 'WR_AJ_00', text: '선택', option: 'select' },
        {
          code: 'WR_AJ_01',
          text: '손목이 중립에서 반정도 비틀어짐',
          option: 'select',
        },
        { code: 'WR_AJ_02', text: '손목이 완전히 비틀어짐', option: 'select' },
        { code: 'WR_AJ_03', text: '손목이 옆으로 굽혀짐', option: 'check' },
      ],
    },
    weight: {
      text: '무게/하중',
      data: [
        { code: 'WT_01', text: '2kg 미만', option: 'radio' },
        { code: 'WT_02', text: '2 ~ 5kg', option: 'radio' },
        { code: 'WT_03', text: '5 ~ 10kg', option: 'radio' },
        { code: 'WT_04', text: '10 ~ 20kg', option: 'radio' },
        { code: 'WT_05', text: '20kg 이상', option: 'radio' },
      ],
    },
    frequency: {
      text: '빈도/강도',
      data: [
        { code: 'FQ_01', text: '가끔 물건을 들어올림', option: 'radio' },
        { code: 'FQ_02', text: '정적이거나 반복작업을 수행', option: 'radio' },
        {
          code: 'FQ_03',
          text: '갑작스럽게 물건을 들어올리거나 충격을 받음',
          option: 'radio',
        },
      ],
    },
    add: {
      text: '추가사항',
      data: [
        { code: 'AD_01', text: '1분이상 정적자세', option: 'check' },
        { code: 'AD_02', text: '분당  4회 이상 반복', option: 'check' },
        {
          code: 'AD_03',
          text: '동작으로 자세가 급변하거나 불안정한 지지면에서 수행됨',
          option: 'check',
        },
      ],
    },
    handle: {
      text: '손잡이',
      data: [
        { code: 'HD_01', text: '좋음(적절한 손잡이)', option: 'radio' },
        { code: 'HD_02', text: '보통(대용 손잡이)', option: 'radio' },
        {
          code: 'HD_03',
          text: '나쁨(부적절한 손잡이)',
          option: 'radio',
        },
        {
          code: 'HD_04',
          text: '부적절(손잡이 없음)',
          option: 'radio',
        },
      ],
    },
  };

  const convertDataToPoseInfo = data => {
    return {
      neck: {
        position: data?.neckPt,
        adjust: {
          check: {
            NC_AJ_01: data?.neckTwistedYn,
            NC_AJ_02: data?.neckBendedYn,
          },
        },
      },
      trunk: {
        pose: data?.trunkPs,
        position: data?.trunkPt,
        adjust: {
          check: {
            TR_AJ_01: data?.trunkTwistedYn,
            TR_AJ_02: data?.trunkBendedYn,
          },
        },
      },
      leg: {
        pose: data?.legPs,
        position: data?.legPt,
        adjust: {
          select: data?.legAg,
          check: {
            LG_AJ_03: data?.legSittedSupportedYn,
            LG_AJ_04: data?.legSittedNotSupportedYn,
          },
        },
      },
      upperArm: {
        position: data?.upperArmPt,
        adjust: {
          check: {
            UA_AJ_01: data?.upperArmAbductedYn,
            UA_AJ_02: data?.upperArmRaisedYn,
            UA_AJ_03: data?.upperArmSupportedYn,
          },
        },
      },
      lowerArm: {
        pose: data?.lowerArmPs,
        position: data?.lowerArmPt,
        adjust: {
          check: {
            LA_AJ_01: data?.lowerArmOutbodyYn,
          },
        },
      },
      wrist: {
        position: data?.wristPt,
        adjust: {
          select: data?.wristTwist,
          check: {
            WR_AJ_03: data?.wristBendedYn,
          },
        },
      },
      weight: data?.weight,
      frequency: data?.freqIntens,
      handle: data?.coupling,
      add: {
        AD_01: data?.staticYn,
        AD_02: data?.reptYn,
        AD_03: data?.unstableYn,
      },
    };
  };

  const convertPoseInfoToData = poseInfo => {
    return {
      neckPt: poseInfo.neck.position,
      neckTwistedYn: poseInfo.neck.adjust.check.NC_AJ_01,
      neckBendedYn: poseInfo.neck.adjust.check.NC_AJ_02,
      trunkPs: poseInfo.trunk.pose,
      trunkPt: poseInfo.trunk.position,
      trunkTwistedYn: poseInfo.trunk.adjust.check.TR_AJ_01,
      trunkBendedYn: poseInfo.trunk.adjust.check.TR_AJ_02,
      legPs: poseInfo.leg.pose,
      legPt: poseInfo.leg.position,
      legAg: poseInfo.leg.adjust.select,
      legSittedSupportedYn: poseInfo.leg.adjust.check.LG_AJ_03,
      legSittedNotSupportedYn: poseInfo.leg.adjust.check.LG_AJ_04,
      upperArmPt: poseInfo.upperArm.position,
      upperArmAbductedYn: poseInfo.upperArm.adjust.check.UA_AJ_01,
      upperArmRaisedYn: poseInfo.upperArm.adjust.check.UA_AJ_02,
      upperArmSupportedYn: poseInfo.upperArm.adjust.check.UA_AJ_03,
      lowerArmPs: poseInfo.lowerArm.pose,
      lowerArmPt: poseInfo.lowerArm.position,
      lowerArmOutBodyYn: poseInfo.lowerArm.adjust.check.LA_AJ_01,
      wristPt: poseInfo.wrist.position,
      wristTwist: poseInfo.wrist.adjust.select,
      wristBendedYn: poseInfo.wrist.adjust.check.WR_AJ_03,
      weight: poseInfo.weight,
      freqIntens: poseInfo.frequency,
      coupling: poseInfo.handle,
      staticYn: poseInfo.add.AD_01,
      reptYn: poseInfo.add.AD_02,
      unstableYn: poseInfo.add.AD_03,
    };
  };

  const [poseInfo, setPoseInfo] = useState(() => {
    return convertDataToPoseInfo(valueObj.scoreList[0]);
  });

  useEffect(() => {
    if (['TR_PS_03', 'TR_PS_04'].includes(poseInfo.trunk.pose)) {
      setPoseInfo({
        ...poseInfo,
        trunk: {
          ...poseInfo.trunk,
          adjust: {
            ...poseInfo.trunk.adjust,
            check: {
              ...poseInfo.trunk.adjust.check,
              TR_AJ_01: 'Y',
            },
          },
        },
      });
    }
  }, [poseInfo.trunk.pose]);

  useEffect(() => {
    if (poseInfo.leg.pose === 'LG_PS_01') {
      setPoseInfo({
        ...poseInfo,
        leg: {
          ...poseInfo.leg,
          adjust: {
            ...poseInfo.leg.adjust,
            check: {
              ...poseInfo.leg.adjust.check,
              LG_AJ_03: 'Y',
            },
          },
        },
      });
    }
  }, [poseInfo.leg.pose]);

  useEffect(() => {
    if (poseInfo.leg.adjust.check.LG_AJ_03 === 'Y') {
      setPoseInfo({
        ...poseInfo,
        leg: {
          ...poseInfo.leg,
          adjust: {
            ...poseInfo.leg.adjust,
            check: {
              ...poseInfo.leg.adjust.check,
              LG_AJ_04: 'N',
            },
          },
        },
      });
    }
  }, [poseInfo.leg.adjust.check.LG_AJ_03]);

  useEffect(() => {
    if (poseInfo.leg.adjust.check.LG_AJ_04 === 'Y') {
      setPoseInfo({
        ...poseInfo,
        leg: {
          ...poseInfo.leg,
          adjust: {
            ...poseInfo.leg.adjust,
            check: {
              ...poseInfo.leg.adjust.check,
              LG_AJ_03: 'N',
            },
          },
        },
      });
    }
  }, [poseInfo.leg.adjust.check.LG_AJ_04]);

  useEffect(() => {
    if (poseInfo.frequency === 'FQ_03') {
      setPoseInfo({
        ...poseInfo,
        add: {
          ...poseInfo.add,
          AD_03: 'Y',
        },
      });
    }
  }, [poseInfo.frequency]);

  useEffect(() => {
    const newScoreList = [...valueObj.scoreList];
    for (let i = 0; i < newScoreList.length; i++) {
      if (
        newScoreList[i].frameNo === selectedData.frameNo &&
        newScoreList[i].anlsTrprLbl === selectedData.anlsTrprLbl
      ) {
        newScoreList[i] = {
          ...selectedData,
          ...convertPoseInfoToData(poseInfo),
          ...analyzePose(poseInfo),
        };
        setValueObj({ ...valueObj, scoreList: newScoreList });
        //onChangeRslt(valueObj.index, 'scoreList', newScoreList);
        setSelectedData(newScoreList[i]);
        break;
      }
    }
  }, [poseInfo]);

  return (
    <>
      {frameList.length > 0 ? (
        <>
          <div className="tbl-wrap">
            <table className="tbl row data scroll divide">
              <tbody>
                <tr>
                  <th>OWAS 최고점수</th>
                  <th>RULA 최고점수</th>
                  <th>REBA 최고점수</th>
                </tr>
                <tr>
                  <ColloredTd1 scrType="OWAS" scr={pageParam.exprtOwas} />
                  <ColloredTd1 scrType="RULA" scr={pageParam.exprtRula} />
                  <ColloredTd1 scrType="REBA" scr={pageParam.exprtReba} />
                </tr>
              </tbody>
            </table>
            <table className="tbl data row">
              <tbody>
                <tr>
                  <th scope="row">라벨</th>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="selected"
                        id="selectedLbl"
                      >
                        라벨
                      </label>
                      <select
                        className="form-select md"
                        id="selected"
                        value={selectedLbl}
                        onChange={e => {
                          setSelectedLbl(e.target.value);
                        }}
                        aria-labelledby="selectedLbl"
                      >
                        {lblList.map((lbl, index) => {
                          return (
                            <option key={index} value={lbl.lbl}>
                              {lbl.lbl}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="tbl-wrap">
            <div className="img-wrap">
              <div className="img-item">
                <div className="img-item">
                  <img
                    src={
                      frameList.filter(
                        frame => frame.frameNo === selectedFrame
                      )[0]?.thmb
                    }
                    alt="Main Display"
                  />
                </div>
              </div>
              <div className="img-list">
                <div className="img-list-inner">
                  {frameList.map((img, index) => (
                    <a
                      className={`img-list-item ${
                        img.frameNo === selectedFrame ? 'active' : ''
                      }`}
                      key={index}
                      onClick={e => {
                        e.preventDefault();
                        setSelectedFrame(img.frameNo);
                      }}
                    >
                      <img src={img?.thmb} alt={`Thumbnail ${index + 1}`} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <table className="tbl data row scroll divide">
              <colgroup>
                <col style={{ width: '7%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '8%' }} />
                <col style={{ width: '8%' }} />
              </colgroup>
              <tbody>
                <tr>
                  <th>구분</th>
                  <th colSpan={2}>자세 정보</th>
                  <th colSpan={2}>부가 정보</th>
                  <th className="bg1">OWAS</th>
                  <th className="bg1">RULA</th>
                  <th className="bg1">REBA</th>
                </tr>
                <tr>
                  <th>{options.neck.text}</th>
                  <td colSpan={2}>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.neck.position}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            neck: {
                              ...poseInfo.neck,
                              position: e.target.value,
                            },
                          });
                        }}
                        disabled
                      >
                        {options.neck.position.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td colSpan={2}>
                    <div className="inner-list">
                      {options.neck.adjust
                        .filter(option => option.option === 'check')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              name={option.code}
                              id={option.code}
                              checked={
                                poseInfo.neck.adjust.check[option.code] === 'Y'
                              }
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  neck: {
                                    ...poseInfo.neck,
                                    adjust: {
                                      ...poseInfo.neck.adjust,
                                      check: {
                                        ...poseInfo.neck.adjust.check,
                                        [option.code]:
                                          poseInfo.neck.adjust.check[
                                            option.code
                                          ] === 'Y'
                                            ? 'N'
                                            : 'Y',
                                      },
                                    },
                                  },
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td rowSpan={2}>{selectedData?.owasTrunkScr}</td>
                  <td>{selectedData?.rulaNeckScr}</td>
                  <td>{selectedData?.rebaNeckScr}</td>
                </tr>
                <tr>
                  <th>{options.trunk.text}</th>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.trunk.pose}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            trunk: { ...poseInfo.trunk, pose: e.target.value },
                          });
                        }}
                        disabled
                      >
                        {options.trunk.pose.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.trunk.position}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            trunk: {
                              ...poseInfo.trunk,
                              position: e.target.value,
                            },
                          });
                        }}
                        disabled
                      >
                        {options.trunk.position.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="inner-list">
                      {options.trunk.adjust
                        .filter(option => option.option === 'check')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              name={option.code}
                              id={option.code}
                              checked={
                                poseInfo.trunk.adjust.check[option.code] === 'Y'
                              }
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  trunk: {
                                    ...poseInfo.trunk,
                                    adjust: {
                                      ...poseInfo.trunk.adjust,
                                      check: {
                                        ...poseInfo.trunk.adjust.check,
                                        [option.code]:
                                          poseInfo.trunk.adjust.check[
                                            option.code
                                          ] === 'Y'
                                            ? 'N'
                                            : 'Y',
                                      },
                                    },
                                  },
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td rowSpan={2}>
                    <div className="inner-list">
                      {options.leg.adjust
                        .filter(option => option.option === 'check')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              name={option.code}
                              id={option.code}
                              checked={
                                poseInfo.leg.adjust.check[option.code] === 'Y'
                              }
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  leg: {
                                    ...poseInfo.leg,
                                    adjust: {
                                      ...poseInfo.leg.adjust,
                                      check: {
                                        ...poseInfo.leg.adjust.check,
                                        ...poseInfo.leg.adjust.select,
                                        [option.code]:
                                          poseInfo.leg.adjust.check[
                                            option.code
                                          ] === 'Y'
                                            ? 'N'
                                            : 'Y',
                                      },
                                    },
                                  },
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>{selectedData?.rulaTrunkScr}</td>
                  <td>{selectedData?.rebaTrunkScr}</td>
                </tr>
                <tr>
                  <th>{options.leg.text}</th>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.leg.pose}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            leg: { ...poseInfo.leg, pose: e.target.value },
                          });
                        }}
                        disabled
                      >
                        {options.leg.pose.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.leg.position}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            leg: { ...poseInfo.leg, position: e.target.value },
                          });
                        }}
                        disabled
                      >
                        {options.leg.position.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.leg.adjust.select}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            leg: {
                              ...poseInfo.leg,
                              adjust: {
                                ...poseInfo.leg.adjust,
                                select: e.target.value,
                              },
                            },
                          });
                        }}
                        disabled
                      >
                        {options.leg.adjust
                          .filter(option => option.option === 'select')
                          .map(option => (
                            <option
                              key={option.code}
                              value={option.code}
                              id={option.code}
                            >
                              {option.text}
                            </option>
                          ))}
                      </select>
                    </div>
                  </td>

                  <td>{selectedData?.owasLegScr}</td>
                  <td>{selectedData?.rulaLegScr}</td>
                  <td>{selectedData?.rebaLegScr}</td>
                </tr>
                <tr>
                  <th>{options.upperArm.text}</th>
                  <td colSpan={2}>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.upperArm.position}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            upperArm: {
                              ...poseInfo.upperArm,
                              position: e.target.value,
                            },
                          });
                        }}
                        disabled
                      >
                        {options.upperArm.position.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td colSpan={2}>
                    <div className="inner-list">
                      {options.upperArm.adjust
                        .filter(option => option.option === 'check')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              name={option.code}
                              id={option.code}
                              checked={
                                poseInfo.upperArm.adjust.check[option.code] ===
                                'Y'
                              }
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  upperArm: {
                                    ...poseInfo.upperArm,
                                    adjust: {
                                      ...poseInfo.upperArm.adjust,
                                      check: {
                                        ...poseInfo.upperArm.adjust.check,
                                        [option.code]:
                                          poseInfo.upperArm.adjust.check[
                                            option.code
                                          ] === 'Y'
                                            ? 'N'
                                            : 'Y',
                                      },
                                    },
                                  },
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td rowSpan={4}>{selectedData?.owasArmScr}</td>
                  <td>{selectedData?.rulaUpperArmScr}</td>
                  <td>{selectedData?.rebaUpperArmScr}</td>
                </tr>
                <tr>
                  <th>{options.lowerArm.text}</th>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.lowerArm.pose}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            lowerArm: {
                              ...poseInfo.lowerArm,
                              pose: e.target.value,
                            },
                          });
                        }}
                        disabled
                      >
                        {options.lowerArm.pose.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.lowerArm.position}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            lowerArm: {
                              ...poseInfo.lowerArm,
                              position: e.target.value,
                            },
                          });
                        }}
                        disabled
                      >
                        {options.lowerArm.position.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td colSpan={2}>
                    <div className="inner-list">
                      {options.lowerArm.adjust
                        .filter(option => option.option === 'check')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              name={option.code}
                              id={option.code}
                              checked={
                                poseInfo.lowerArm.adjust.check[option.code] ===
                                'Y'
                              }
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  lowerArm: {
                                    ...poseInfo.lowerArm,
                                    adjust: {
                                      ...poseInfo.lowerArm.adjust,
                                      check: {
                                        ...poseInfo.lowerArm.adjust.check,
                                        [option.code]:
                                          poseInfo.lowerArm.adjust.check[
                                            option.code
                                          ] === 'Y'
                                            ? 'N'
                                            : 'Y',
                                      },
                                    },
                                  },
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>{selectedData?.rulaLowerArmScr}</td>
                  <td>{selectedData?.rebaLowerArmScr}</td>
                </tr>
                <tr>
                  <th>{options.wrist.text}</th>
                  <td rowSpan={2} colSpan={2}>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.wrist.position}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            wrist: {
                              ...poseInfo.wrist,
                              position: e.target.value,
                            },
                          });
                        }}
                        disabled
                      >
                        {options.wrist.position.map(option => (
                          <option
                            key={option.code}
                            value={option.code}
                            id={option.code}
                          >
                            {option.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td rowSpan={2}>
                    <div className="input-group">
                      <select
                        className="form-select md"
                        value={poseInfo.wrist.adjust.select}
                        onChange={e => {
                          setPoseInfo({
                            ...poseInfo,
                            wrist: {
                              ...poseInfo.wrist,
                              adjust: {
                                ...poseInfo.wrist.adjust,
                                select: e.target.value,
                              },
                            },
                          });
                        }}
                        disabled
                      >
                        {options.wrist.adjust
                          .filter(option => option.option === 'select')
                          .map(option => (
                            <option
                              key={option.code}
                              value={option.code}
                              id={option.code}
                            >
                              {option.text}
                            </option>
                          ))}
                      </select>
                    </div>
                  </td>
                  <td rowSpan={2}>
                    <div className="inner-list">
                      <div className="inner-list">
                        {options.wrist.adjust
                          .filter(option => option.option === 'check')
                          .map(option => (
                            <div className="form-check">
                              <input
                                type="checkbox"
                                name={option.code}
                                id={option.code}
                                checked={
                                  poseInfo.wrist.adjust.check[option.code] ===
                                  'Y'
                                }
                                onChange={e => {
                                  setPoseInfo({
                                    ...poseInfo,
                                    wrist: {
                                      ...poseInfo.wrist,
                                      adjust: {
                                        ...poseInfo.wrist.adjust,
                                        check: {
                                          ...poseInfo.wrist.adjust.check,
                                          [option.code]:
                                            poseInfo.wrist.adjust.check[
                                              option.code
                                            ] === 'Y'
                                              ? 'N'
                                              : 'Y',
                                        },
                                      },
                                    },
                                  });
                                }}
                                disabled
                              />
                              <label
                                htmlFor={option.code}
                                style={{ textAlign: 'left' }}
                              >
                                <span>{option.text}</span>
                              </label>
                            </div>
                          ))}
                      </div>
                    </div>
                  </td>
                  <td>{selectedData?.rulaWristScr}</td>
                  <td rowSpan={2}>{selectedData?.rebaWristScr}</td>
                </tr>
                <tr>
                  <th>손목 비틀림</th>
                  <td>{selectedData?.rulaWristTwistScr}</td>
                </tr>
              </tbody>
            </table>
            <table
              className="tbl data row scroll divide"
              style={{ borderTop: '1px solid #fff' }}
            >
              <colgroup>
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
              </colgroup>
              <tbody>
                <tr>
                  <th>무게</th>
                  <th>빈도</th>
                  <th>손잡이</th>
                  <th>추가사항</th>
                </tr>
                <tr>
                  <td>
                    <div className="inner-list">
                      {options.weight.data
                        .filter(option => option.option === 'radio')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="radio"
                              name="weight"
                              id={option.code}
                              value={option.code}
                              checked={poseInfo?.weight === option.code}
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  weight: e.target.value,
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>
                    <div className="inner-list">
                      {options.frequency.data
                        .filter(option => option.option === 'radio')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="radio"
                              name="frequency"
                              id={option.code}
                              value={option.code}
                              checked={poseInfo?.frequency === option.code}
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  frequency: e.target.value,
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>
                    <div className="inner-list">
                      {options.handle.data
                        .filter(option => option.option === 'radio')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="radio"
                              name="handle"
                              id={option.code}
                              value={option.code}
                              checked={poseInfo?.handle === option.code}
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  handle: e.target.value,
                                });
                              }}
                              disabled
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>
                    <div className="inner-list">
                      {options.add.data
                        .filter(option => option.option === 'check')
                        .map(option => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              name={option.code}
                              id={option.code}
                              checked={poseInfo.add[option.code] === 'Y'}
                              onChange={e => {
                                setPoseInfo({
                                  ...poseInfo,
                                  add: {
                                    ...poseInfo.add,
                                    [option.code]:
                                      poseInfo.add[option.code] === 'Y'
                                        ? 'N'
                                        : 'Y',
                                  },
                                });
                              }}
                              disabled
                              className={'readOnly'}
                            />
                            <label
                              htmlFor={option.code}
                              style={{ textAlign: 'left' }}
                            >
                              <span>{option.text}</span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="tbl data row scroll divide">
              <colgroup>
                <col style={{ width: '75%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '8%' }} />
                <col style={{ width: '8%' }} />
              </colgroup>
              <tbody>
                <tr>
                  <th className="bg1">scores</th>
                  <td>{selectedData?.owasScr}</td>
                  <td>{selectedData?.rulaScr}</td>
                  <td>{selectedData?.rebaScr}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="tbl-wrap">
            <table className="tbl row data scroll divide">
              <tbody>
                <tr>
                  <th></th>
                  <th style={{ backgroundColor: '#28a745' }}></th>
                  <th style={{ backgroundColor: '#fff700' }}></th>
                  <th style={{ backgroundColor: '#ffa600' }}></th>
                  <th style={{ backgroundColor: '#ff4200' }}></th>
                  <th style={{ backgroundColor: '#dc3545' }}></th>
                </tr>
                <tr>
                  <th>위험수준</th>
                  <td>매우 낮음</td>
                  <td>낮음</td>
                  <td>중간</td>
                  <td>높음</td>
                  <td>매우높음</td>
                </tr>
                <tr>
                  <th>조치필요성</th>
                  <td>없음</td>
                  <td>모니터링</td>
                  <td>필요함</td>
                  <td>빠른조치필요</td>
                  <td>즉시조치필요</td>
                </tr>
                <tr>
                  <th className="bg3">OWAS</th>
                  <ColloredTd
                    color="#28a745"
                    colspan="2"
                    text="AC1"
                    selected={selectedData?.owasScrRange === 1}
                  />
                  <ColloredTd
                    color="#ffa600"
                    colspan="1"
                    text="AC2"
                    selected={selectedData?.owasScrRange === 2}
                  />
                  <ColloredTd
                    color="#ff4200"
                    colspan="1"
                    text="AC3"
                    selected={selectedData?.owasScrRange === 3}
                  />
                  <ColloredTd
                    color="#dc3545"
                    colspan="1"
                    text="AC4"
                    selected={selectedData?.owasScrRange === 4}
                  />
                </tr>
                <tr>
                  <th className="bg3">RULA</th>
                  <ColloredTd
                    color="#28a745"
                    colspan="1"
                    text="1-2"
                    selected={selectedData?.rulaScrRange === 1}
                  />
                  <ColloredTd
                    color="#fff700"
                    colspan="1"
                    text="3-4"
                    selected={selectedData?.rulaScrRange === 3}
                  />
                  <ColloredTd
                    color="#ffa600"
                    colspan="2"
                    text="5-6"
                    selected={selectedData?.rulaScrRange === 5}
                  />
                  <ColloredTd
                    color="#dc3545"
                    colspan="1"
                    text="7이상"
                    selected={selectedData?.rulaScrRange === 7}
                  />
                </tr>
                <tr>
                  <th className="bg3">REBA</th>
                  <ColloredTd
                    color="#28a745"
                    colspan="1"
                    text="1"
                    selected={selectedData?.rebaScrRange === 1}
                  />
                  <ColloredTd
                    color="#fff700"
                    colspan="1"
                    text="2-3"
                    selected={selectedData?.rebaScrRange === 2}
                  />
                  <ColloredTd
                    color="#ffa600"
                    colspan="1"
                    text="4-7"
                    selected={selectedData?.rebaScrRange === 4}
                  />
                  <ColloredTd
                    color="#ff4200"
                    colspan="1"
                    text="8-10"
                    selected={selectedData?.rebaScrRange === 8}
                  />
                  <ColloredTd
                    color="#dc3545"
                    colspan="1"
                    text="11이상"
                    selected={selectedData?.rebaScrRange === 11}
                  />
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <p className="tbl-msg tbl-msg--box">
          위험한 유해요인이 발견되지 않았습니다.
        </p>
      )}
    </>
  );
};

export default ConsultTotalResult;
